export default __webpack_public_path__ + "static/media/banks.a8f350a0.svg";